import React from 'react'
import { useTranslations } from 'next-intl'
import { toast } from 'react-hot-toast'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { Button } from "@/components/ui/button"
import { CopyIcon, DownloadIcon } from 'lucide-react'
import { TableOutputProps } from '@/lib/table/types'
import { download } from '@/utils/blob'

export function TableOutput({ value, format, onFormatChange, jsonFormat, onJsonFormatChange }: TableOutputProps) {
  const t = useTranslations('MarkdownTable')

  // 复制输出结果
  const handleCopy = () => {
    navigator.clipboard.writeText(value)
      .then(() => toast.success(t('copySuccess')))
      .catch(() => toast.error(t('copyError')))
  }

  // 下载输出结果
  const handleDownload = () => {
    const blob = new Blob([value], { type: 'text/plain;charset=utf-8' })
    let filename = 'table'
    
    if (format === 'markdown') {
      filename += '.md'
    } else if (format === 'csv') {
      filename += '.csv'
    } else if (format === 'json') {
      filename += '.json'
    }
    
    download(blob, filename)
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold">{t('outputTitle')}</h2>
        <div className="flex space-x-2">
          <Select value={format} onValueChange={onFormatChange}>
            <SelectTrigger className="w-40">
              <SelectValue placeholder={t('selectOutputFormat')} />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="markdown">Markdown</SelectItem>
              <SelectItem value="csv">CSV</SelectItem>
              <SelectItem value="json">JSON</SelectItem>
            </SelectContent>
          </Select>
          
          {format === 'json' && (
            <Select value={jsonFormat} onValueChange={onJsonFormatChange}>
              <SelectTrigger className="w-40">
                <SelectValue placeholder={t('selectJsonFormat')} />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="object">{t('objectFormat')}</SelectItem>
                <SelectItem value="array">{t('arrayFormat')}</SelectItem>
              </SelectContent>
            </Select>
          )}
        </div>
      </div>
      
      <div className="relative">
        <textarea
          className="w-full h-80 p-4 font-mono text-sm app-input"
          value={value}
          readOnly
          spellCheck={false}
        />
        <div className="absolute bottom-4 right-4 flex space-x-2">
          <Button size="sm" variant="secondary" onClick={handleCopy}>
            <CopyIcon className="w-4 h-4 mr-2" />
            {t('copyButton')}
          </Button>
          <Button size="sm" variant="secondary" onClick={handleDownload}>
            <DownloadIcon className="w-4 h-4 mr-2" />
            {t('downloadButton')}
          </Button>
        </div>
      </div>
    </div>
  )
} 